module.exports = __webpack_public_path__ + "media/assets/images/blog/iot_horeca-37710560205a412cd3e9e76f2661204f.png";